module.exports = __webpack_public_path__ + "img/chinesecompany262.45085801.png";